import { RouteRecordRaw } from 'vue-router'

export const creativeAutomationListingRoute: RouteRecordRaw[] = [
  {
    name: 'creativeAutomationListing',
    path: 'creativeAutomation',
    component: () => import('./CreativeAutomationListing.vue'),
    meta: {
      title: 'Creative Automation'
    }
  },
  {
    name: 'CreateCreatives',
    path: 'creativeAutomation/create',
    component: () => import('@/views/CreativeAutomation/Create.vue'),
    meta: {
      title: 'Creatives'
    }
  },
  {
    path: 'creativeAutomation/edit/:id',
    name: 'EditCreatives',
    component: () => import('@/views/CreativeAutomation/Create.vue'),
    meta: {
      title: 'Update Creatives',
      bpSwitchFallback: 'creativeAutomationListing'
    },
    beforeEnter: async (to, from, next) => {
      if (!to.params.id) {
        next({ name: 'CreateCreatives' })
      } else {
        next()
      }
    }
  },
  {
    path: 'creativeAutomation/clone/:id',
    name: 'CloneCreatives',
    component: () => import('@/views/CreativeAutomation/Create.vue'),
    meta: {
      title: 'Clone Creative',
      bpSwitchFallback: 'creativeAutomationListing'
    },
    beforeEnter: async (to, from, next) => {
      if (!to.params.id) {
        next({ name: 'CreateCreatives' })
      } else {
        next()
      }
    }
  },
  {
    path: 'creativePreview/:id',
    name: 'CreativePreview',
    component: () => import('@/views/CreativeAutomation/CreativePreview.vue'),
    meta: {
      title: 'Product Creative Preview',
      bpSwitchFallback: 'creativeAutomationListing'
    },
    beforeEnter: async (to, from, next) => {
      if (!to.params.id) {
        next({ name: 'creativeAutomationListing' })
      } else {
        next()
      }
    }
  }
]

export default creativeAutomationListingRoute
